import React, { useState } from 'react';

function LoginScreen({ onSignIn }) {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [busy, setBusy] = useState(false);

  const submit = async (event) => {
    event.preventDefault();
    setBusy(true);
    setError('');
    const message = await onSignIn(email.trim(), password);
    if (message) setError(message);
    setBusy(false);
  };

  return (
    <main className="auth-screen">
      <form className="auth-card" onSubmit={submit}>
        <span className="auth-brand">Tefolio</span>
        <h1 className="auth-title">Sign in</h1>
        <label className="dialog-label" htmlFor="login-email">Email</label>
        <input id="login-email" className="dialog-input" type="email" autoComplete="username" autoFocus required disabled={busy} value={email} onChange={(event) => setEmail(event.target.value)} />
        <label className="dialog-label auth-field-gap" htmlFor="login-password">Password</label>
        <input id="login-password" className="dialog-input" type="password" autoComplete="current-password" required disabled={busy} value={password} onChange={(event) => setPassword(event.target.value)} />
        {error && <p className="dialog-error" role="alert">{error}</p>}
        <button className="btn btn-primary auth-submit" type="submit" disabled={busy}>
          {busy ? 'Signing in…' : 'Sign in'}
        </button>
      </form>
    </main>
  );
}

export default LoginScreen;